<script>
import Config from '@/config';
import Size from '@/mixins/size';
import {formatTime, pageIsFinish} from '@/libs/util';
import {referrerGetScore, referrerList} from '@/api';
import {Toast, Field, Button, List, PullRefresh} from 'vant';

export default {
  mixins: [
    Size
  ],
  components: {
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      referrerList: [],

      mobile: '',
      loading: false,
      finished: false,
      refreshing: false,
      listLoading: false,
    };
  },
  computed: {
    disabled() {
      return !this.mobile || this.mobileError;
    },
    mobileError() {
      return Boolean(this.mobile && !(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(this.mobile)));
    }
  },
  mounted() {
    window.document.title = '速电通-我的推荐';
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    loadData() {
      if (this.refreshing) {
        this.referrerList = [];
        this.refreshing = false;
      }

      this.listLoading = true;
      referrerList('', this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          response.data.body.data = response.data.body.data.map(value => {
            value.createdAtShow = formatTime(new Date(value.referrerAt));
            return value;
          });
          this.referrerList = this.page === 1 ? response.data.body.data : this.referrerList.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.listLoading = false).catch(() => this.finished = true);
    },
    submit() {
      this.loading = true;
      referrerGetScore(this.mobile).then(response => {
        if (response.data.code === Config.successCode) {
          this.refresh();
          Toast.success('推荐成功');
        }
      }).finally(() => this.loading = false);
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" id="referrer">
    <van-field v-model="mobile" :error="mobileError" clearable type="number" label="推荐账户" placeholder="请输入推荐账户手机号码" titleWidth="64px"/>
    <div class="tip">
      <div class="label">温馨提示：</div>
      <div class="content">三天内注册并成功充电的用户有效，所获积分可在商城兑换商品或充电费</div>
    </div>
    <div class="submit-button">
      <van-button :disabled="disabled" :loading="loading" @click="submit" v-prevent-re-click round block color="#009251" loading-text="兑换中...">兑换积分</van-button>
    </div>
    <div class="list">
      <div class="title">邀请明细</div>
      <van-list v-model="listLoading" :finished="finished" :finished-text="referrerList.length === 0 ? '' : '没有更多了'" @load="loadData">
        <div v-for="(item, index) in referrerList" :key="index" class="item">
          <div class="left">
            <div class="label">{{ item.mobile }}</div>
            <div class="datetime">{{ item.createdAtShow }}</div>
          </div>
          <div class="change-value add">+{{ item.score }}积分</div>
        </div>
      </van-list>
      <div v-if="referrerList.length === 0" :style="{height: (height - 250) + 'px'}" class="no-data">
        <div class="content">
          <img src="../assets/images/no-data.png"/>
        </div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#referrer {
  background-color: #F8F8F8;
}

#referrer .tip {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  color: #333333;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background-color: white;
  padding: 24px 24px 12px 24px;
}

#referrer .tip .label {
  flex: 1;
  text-align: right;
}

#referrer .tip .content {
  flex: 3;
  text-align: left;
}


#referrer .submit-button {
  background-color: white;
  padding: 0 24px 24px 24px;
}

#referrer .submit-button .van-button {
  box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
}

#referrer .list {
  margin-top: 8px;
  background-color: white;
}

#referrer .list .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 24px 12px 12px 12px;
}

#referrer .list .item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 0;
  margin: 0 12px;
  border-bottom: 1px solid #EEEEEE;
}

#referrer .list .item .left {
  display: flex;
  flex-direction: column;
}

#referrer .list .item .left .label {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

#referrer .list .item .left .datetime {
  color: #9d9d9d;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

#referrer .list .item .change-value {
  font-size: 18px;
  font-weight: bold;
}

#referrer .list .item .change-value.add {
  color: #009251;
}

#referrer .list .item .change-value.sub {
  color: #FC2313;
}
</style>
